/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

window.addEventListener("load", (event) => {
  console.log("iuyiuy");
  if (document.querySelector("#custom-produt-v1")) {
    console.log("herwe iam");
    const qtyWrapper = document.querySelectorAll(".product-form__quantity");

    qtyWrapper.forEach((el, i) => {
      const qty = el
        .querySelector(".quantity-selector__input")
        .getAttribute("mm-min");
      const productForm = el.closest(".product__info");
      const priceEl = productForm.querySelector(".original__price");
      const priceText = productForm.querySelector(".price__text");
      const productPrice = priceEl.innerHTML;

      console.log("879234iuyiuy");
      const newPrice = +qty * productPrice;

      // priceEl.innerHTML = newPrice

      priceText.innerHTML = `(${productPrice} each for ${qty}+)`;

      const qtyInput = el.querySelector(".quantity-selector__input");
      qtyInput.removeAttribute("min");

      const errSpan = productForm.querySelector(".qty__warning");

      qtyInput.addEventListener("change", function (e) {
        console.log("here");

        if (e.target.value < +qty) {
          this.value = +qty;
        } else {
        }
      });

      qtyInput.addEventListener("keyup", function (e) {
        console.log("here1");
        if (e.target.value < +qty) {
          errSpan.innerHTML = `You can not order less than <strong>${qty}</strong>`;
        } else {
          errSpan.innerHTML = "";
        }
      });
    });
  }
});

$(document).ready(function () {
  jQuery(".product-var label").on("click", function () {
    // Fetching the value of the data-variantid attribute
    var variantId = jQuery(this).parent().find("input").data("variantid");
    var variantstock = jQuery(this)
      .parent()
      .find("input")
      .data("variantinventory");
    // Logging the value to the console (you can use it as needed)
    console.log("Variant ID:", variantId);
    console.log("Variant stock:", variantstock);
    if (parseInt(variantstock) < 1) {
      jQuery(".extrabuy").remove();
    } else {
      if (jQuery(".extrabuy").length > 0) {
      } else {
        jQuery(".product-form").append(
          "<p class='extrabuy' style='display:none;''></p>"
        );
      }
    }
  });

  if (jQuery(".extrabuy").length > 0) {
    // The element has the specified class
    console.log('The element has the class "exampleClass"');

    jQuery("body").on("click", ".product-form__add-button", function () {
      if (jQuery(".extrabuy").length > 0) {
        var getinv = jQuery(".variant-swatch.product-var input:checked").attr(
          "data-variantinventory"
        );
        console.log("admin qty====" + getinv);
        var inpitqty = jQuery(
          ".product-form__quantity .quantity-selector__input"
        ).val();
        console.log("box qty====" + inpitqty);
        var colorval = jQuery(".product-form__option-info .colorval").text();
        if (parseInt(inpitqty) > parseInt(getinv)) {
          console.log("here coming ");
          var remainingquant = parseInt(inpitqty) - parseInt(getinv);
          jQuery("#custom-location").val(
            "we can ship " +
              getinv +
              " now and the remaining " +
              remainingquant +
              " will be shipped within 30 days"
          );

          silverBox({
            alertIcon: "info",
            text:
              getinv +
              " of " +
              colorval +
              " will ship now, the remaining " +
              remainingquant +
              " will ship within 30 days. Please confirm that is ok.",
            centerContent: true,
            closeOnOverlayClick: true,
            confirmButton: {
              bgColor: "#3085d6",
              borderColor: "#3085d6",
              textColor: "#fff",
              text: "Confirm",
              closeOnClick: true,
              bgColor: "#FF0000",
              onClick: function (params) {
                console.log("here");
                jQuery("#mini-cart").attr("open", "open");
              },
            },
          });
        } else {
          jQuery("#custom-location").val("");
        }
      }
    });
  }

  jQuery(".product-item__quick-form").on("click", function () {
    console.log("123");
    setTimeout(function () {
      console.log("hwerwe886876876867r");

      if ($(window).width() < 768) {
        jQuery(".popover--quick-buy .color-swatch label").on(
          "click",
          function () {
            console.log("hwerwer");
            // Fetching the value of the data-variantid attribute
            var variantId = jQuery(this)
              .parent()
              .find("input")
              .data("variantid");
            var variantstock = jQuery(this)
              .parent()
              .find("input")
              .data("variantinventory");
            // Logging the value to the console (you can use it as needed)
            console.log("Variant ID:", variantId);
            console.log("Variant stock:", variantstock);
            if (parseInt(variantstock) < 1) {
              jQuery(".extrabuy").remove();
            } else {
              if (jQuery(".extrabuy").length > 0) {
              } else {
                jQuery(".product-form").append(
                  "<p class='extrabuy' style='display:none;''></p>"
                );
              }
            }
          }
        );

        jQuery("body").on(
          "click",
          ".popover--quick-buy .product-form__add-button",
          function () {
            console.log("here");
            if (jQuery(".extrabuy").length > 0) {
              var getinv = jQuery(
                ".popover--quick-buy .color-swatch input:checked"
              ).attr("data-variantinventory");
              console.log("admin qty====" + getinv);
              var inpitqty = jQuery(
                ".popover--quick-buy .product-form__quantity .quantity-selector__input"
              ).val();
              console.log("box qty====" + inpitqty);
              var colorval = jQuery(
                ".popover--quick-buy .product-form__option-info .colorval"
              ).text();
              if (parseInt(inpitqty) > parseInt(getinv)) {
                console.log("here coming ");
                var remainingquant = parseInt(inpitqty) - parseInt(getinv);
                jQuery(".popover--quick-buy #custom-location").val(
                  "we can ship " +
                    getinv +
                    " now and the remaining " +
                    remainingquant +
                    " will be shipped within 30 days"
                );

                silverBox({
                  alertIcon: "info",
                  text:
                    getinv +
                    " of " +
                    colorval +
                    " will ship now, the remaining " +
                    remainingquant +
                    " will ship within 30 days. Please confirm that is ok.",
                  centerContent: true,
                  closeOnOverlayClick: true,
                  confirmButton: {
                    bgColor: "#3085d6",
                    borderColor: "#3085d6",
                    textColor: "#fff",
                    text: "Confirm",
                    closeOnClick: true,
                    bgColor: "#FF0000",
                    onClick: function (params) {
                      console.log("here");
                      jQuery("#mini-cart").attr("open", "open");
                    },
                  },
                });
              } else {
                jQuery("#custom-location").val("");
              }
            }
          }
        );
      } else {
        jQuery(".drawer__content .color-swatch label").on("click", function () {
          console.log("hwerwer");
          // Fetching the value of the data-variantid attribute
          var variantId = jQuery(this).parent().find("input").data("variantid");
          var variantstock = jQuery(this)
            .parent()
            .find("input")
            .data("variantinventory");
          // Logging the value to the console (you can use it as needed)
          console.log("Variant ID:", variantId);
          console.log("Variant stock:", variantstock);
          if (parseInt(variantstock) < 1) {
            jQuery(".extrabuy").remove();
          } else {
            if (jQuery(".extrabuy").length > 0) {
            } else {
              jQuery(".product-form").append(
                "<p class='extrabuy' style='display:none;''></p>"
              );
            }
          }
        });

        jQuery("body").on(
          "click",
          ".drawer__content .product-form__add-button",
          function () {
            if (jQuery(".extrabuy").length > 0) {
              var getinv = jQuery(
                ".drawer__content .color-swatch input:checked"
              ).attr("data-variantinventory");
              console.log("admin qty====" + getinv);
              var inpitqty = jQuery(
                ".drawer__content .product-form__quantity .quantity-selector__input"
              ).val();
              console.log("box qty====" + inpitqty);
              var colorval = jQuery(
                ".drawer__content .product-form__option-info .colorval"
              ).text();
              if (parseInt(inpitqty) > parseInt(getinv)) {
                console.log("here coming ");
                var remainingquant = parseInt(inpitqty) - parseInt(getinv);
                jQuery(".drawer__content #custom-location").val(
                  "we can ship " +
                    getinv +
                    " now and the remaining " +
                    remainingquant +
                    " will be shipped within 30 days"
                );

                silverBox({
                  alertIcon: "info",
                  text:
                    getinv +
                    " of " +
                    colorval +
                    " will ship now, the remaining " +
                    remainingquant +
                    " will ship within 30 days. Please confirm that is ok.",
                  centerContent: true,
                  closeOnOverlayClick: true,
                  confirmButton: {
                    bgColor: "#3085d6",
                    borderColor: "#3085d6",
                    textColor: "#fff",
                    text: "Confirm",
                    closeOnClick: true,
                    bgColor: "#FF0000",
                    onClick: function (params) {
                      console.log("here");
                      jQuery("#mini-cart").attr("open", "open");
                    },
                  },
                });
              } else {
                jQuery("#custom-location").val("");
              }
            }
          }
        );
      }
    }, 2000);
  });
});
